import { useEffect } from 'react';

const BASE_TITLE = 'Roger Healthcare';

/** Nothing else in the app writes document.title, so this hook owns it. */
export function useUnreadTitle(total: number): void {
  useEffect(() => {
    document.title = total > 0 ? `(${total}) ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [total]);
}
